/**
 * Saves booking-related fields to local storage
 * @param {Object} fields - key-value pairs to store
 */
function saveBookingDataToLocalStorage(fields) {
  for (const key in fields) {
    if (fields[key]) {
      localStorage.setItem(key, fields[key]);
    }
  }
}

function handleNewClientForm() {
  const newClientBtn = document.querySelector(".new-client-btn");

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  newClientBtn.addEventListener("click", async function (e) {
    e.preventDefault();

    const emailInput = document.getElementById("NewClientEmail");
    let isValid = true;

    const email = emailInput?.value.trim();
    const emailValidated = validateEmail(email);

    // Validate email
    if (!email || !emailValidated) {
      emailInput.classList.add("login-input_validate");
      isValid = false;
    }

    if (isValid) {
      // check to see if email is already in meevo
      await fetchAsync(
        `https://cleavage-clinic.uc.r.appspot.com/clients/email/${email}`,
        "POST"
      )
        .then((data) => {
          // Error Client Already Exists
          if (data) {
            localStorage.setItem("clientId", data.clientId);
            localStorage.setItem("new_client_temp_access", "true");
            localStorage.setItem("step", "0");
            window.location.href = "/pages/booking";
          }
        })
        .catch((reason) => console.log(reason));

      if (isValid) {
        saveBookingDataToLocalStorage({
          new_client_email: email,
        });
        localStorage.setItem("new_client_temp_access", "true");
        localStorage.setItem("step", "0");
        window.location.href = "/pages/booking";
      }
    }
  });
}

/**
 * Robust HTTP request function using Axios
 * Replaces the old fetchAsync function with better error handling, retries, and timeout management
 * @param {string} url - The URL to make the request to
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param {string|Object} body - Request body (will be parsed if string)
 * @param {Object} options - Additional options for the request
 * @returns {Promise<Object>} - Response data
 */
async function fetchAsync(url, method = "GET", body = null, options = {}) {
  // Fallback to fetch if Axios is not available
  if (typeof axios === "undefined") {
    console.warn("⚠️ Axios not available, falling back to fetch API");
    try {
      const response = await fetch(url, {
        method: method,
        body: body,
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      });

      if (!response.ok) {
        throw new Error(
          `HTTP error! status: ${response.status} ${response.statusText}`
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("❌ Fetch fallback failed:", error);
      throw error;
    }
  }

  try {
    // Configure Axios request
    const config = {
      url: url,
      method: method.toLowerCase(),
      timeout: options.timeout || 30000, // 30 second timeout
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        ...options.headers,
      },
      // Retry configuration
      retry: options.retry || 3,
      retryDelay: options.retryDelay || 1000,
      // Validate status codes
      validateStatus: function (status) {
        return status >= 200 && status < 300; // Default range
      },
    };

    // Add request body if provided
    if (body) {
      if (typeof body === "string") {
        try {
          config.data = JSON.parse(body);
        } catch (e) {
          config.data = body;
        }
      } else {
        config.data = body;
      }
    }

    // Add retry interceptor for failed requests
    const axiosInstance = axios.create();

    axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const config = error.config;

        // If we haven't set up retry yet, set it up
        if (!config || !config.retry) return Promise.reject(error);

        // If we've exhausted retries, reject
        if (!config.__retryCount) config.__retryCount = 0;
        if (config.__retryCount >= config.retry) {
          return Promise.reject(error);
        }

        // Increment retry count
        config.__retryCount += 1;

        // Only retry on network errors or 5xx server errors
        if (
          error.code === "NETWORK_ERROR" ||
          error.code === "TIMEOUT" ||
          (error.response && error.response.status >= 500)
        ) {
          console.log(
            `🔄 Retrying request (${config.__retryCount}/${config.retry}):`,
            url
          );

          // Wait before retrying
          await new Promise((resolve) =>
            setTimeout(resolve, config.retryDelay * config.__retryCount)
          );

          return axiosInstance(config);
        }

        return Promise.reject(error);
      }
    );

    console.log(`🌐 Making ${method} request to:`, url);
    if (body) console.log(`📤 Request body:`, config.data);

    const response = await axiosInstance(config);

    console.log(`📡 Response received (${response.status}):`, response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Request failed:", {
      url,
      method,
      error: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
    });

    // Handle different types of errors
    if (error.code === "ECONNABORTED" || error.message.includes("timeout")) {
      throw new Error(
        `Request timed out after ${config.timeout / 1000} seconds`
      );
    }

    if (error.response) {
      // Server responded with error status
      const status = error.response.status;
      const statusText = error.response.statusText;
      throw new Error(`HTTP error! status: ${status} ${statusText}`);
    }

    if (error.request) {
      // Request was made but no response received
      throw new Error("Network error: No response received from server");
    }

    // Something else happened
    throw new Error(`Request failed: ${error.message}`);
  }
}

function handleLoginTabs() {
  document.querySelectorAll(".login-page__tab").forEach((tab) => {
    tab.addEventListener("click", function () {
      const selectedTab = this.getAttribute("data-tab");

      document
        .querySelectorAll(".login-page__tab")
        .forEach((t) => t.classList.remove("active"));
      this.classList.add("active");

      const loginWrapper = document.getElementById("login-form");
      const newClientWrapper = document.getElementById("new-client-wrapper");

      if (selectedTab === "new") {
        loginWrapper.style.display = "none";
        newClientWrapper.style.display = "block";

        handleNewClientForm();
      } else {
        loginWrapper.style.display = "block";
        newClientWrapper.style.display = "none";
      }
    });
  });
}

function preFillFields() {
  const emailInput = document.getElementById("RegisterForm-email");
  const storedEmail = localStorage.getItem("new_client_email");
  const isLoggedIn = window.customerIsLoggedIn;

  if (!isLoggedIn && emailInput && storedEmail && emailInput.value === "") {
    emailInput.value = storedEmail;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  preFillFields();
  handleLoginTabs();
});
